
document.addEventListener("DOMContentLoaded", function(event){


    const ucEl = document.querySelectorAll(".openUserCentrics");
    
    
      ucEl.forEach((element)=>{
    
    
        element.addEventListener("click", ()=>{
    
    
    if(typeof usercentrics == "object") {
          if (usercentrics.isInitialized) {
            usercentrics.updateCornerModalIsVisible(true);
          } else {
            usercentrics.toggleBannerIsVisible(true);
          }
        }
    
        // COMP v2
        if (window.UC_UI && window.UC_UI.isInitialized()) {
          window.UC_UI.showSecondLayer();
        } else {
          window.addEventListener('UC_UI_INITIALIZED', function(e) {
            window.UC_UI.showSecondLayer();
          });
        }
      });
    
    
          
        })
    
    
    
      
    window.addEventListener('UC_UI_INITIALIZED', function() {
      // add alt button styles to the shadowroot once UC is initialized
      var uc_button_style = document.createElement( 'style' )
      uc_button_style.innerHTML = '.ghNvoN { background-color: rgb(244,167,182); color: rgb(255,255,255); }'
      document.getElementById('usercentrics-root').shadowRoot.appendChild( uc_button_style )
    
      // add data-nosnippet to cookie banner to stop it being indexed
      setTimeout(()=>{
        var parent=document.getElementById('usercentrics-root').shadowRoot.querySelector("#uc-center-container");
        var title=document.getElementById('usercentrics-root').shadowRoot.querySelector(".sc-AjmZR");
        var desc=document.getElementById('usercentrics-root').shadowRoot.querySelector(".sc-gGCCur");
                
        if(parent) parent.setAttribute("data-nosnippet", "true");
        if(title) title.setAttribute("data-nosnippet", "true");
        if(desc) desc.setAttribute("data-nosnippet", "true");
      },2000)
    });
    
        
      })
    